<!-- <div
  class="image-container container"
  style="background-image: url('/assets/images/lifestyle/facilitati.jpg')"
>
  <h3
    class="title"
  >
    Istorie
  </h3>
</div> -->

<h1
  class="page-title"
>
  Istorie
</h1>

<div class="container">
  <p class="note">
    Du-te cu cursorul peste poză pentru a vedea cum era zona în 2009.
  </p>

  <app-before-after-comparison
    beforeImageUrl="/assets/images/about-us/2019.webp"
    afterImageUrl="/assets/images/about-us/2009.webp"

  ></app-before-after-comparison>

  <p>
    Dream Residence s-a născut din dorința de a face ceva diferit și din a crea un “acasă” perfect pentru fiecare rezident. În 2012 am decis să construim mai mult decât un loc, să construim o poveste pentru familia ta. La sfârșitul anului 2014, proiectul a fost finalizat.
  </p>

  <p>
    În 2015 a apărut un nou vis - faza a V-a a proiectului Dream Residence, ce a reunit 10 imobile. Acesta a fost încheiat în decembrie 2018.
  </p>

  <p>
    În prezent, familia Dream Residence e din ce în ce mai mare, într-un loc unde poți crea amintirile ideale, alături de cei dragi, în locul în care îți oferim toate beneficiile unui trai modern și calitativ. Astăzi găzduim locatari în 935 de apartamente.
  </p>
</div>



// WEBPACK FOOTER //
// ./src/app/about-us/history.component.html